import { FC } from "react";
import { PENDING_TABLE } from "src/constants/todos";

const PendingTableHeader: FC = () => (
  <thead className="sticky-top z-1">
    {/* <tr>
      <th colSpan={8}></th>
      <th className="colspan-head text-center" colSpan={2}>
        Medical Coverage (Buy & Bill)
        <span className="border"></span>
      </th>
      <th className="colspan-head text-center" colSpan={2}>
        Pharmacy Coverage (Speciality Pharmacy)
        <span className="border"></span>
      </th>
    </tr> */}
    <tr className="text-center">
      {PENDING_TABLE.map((header, i) => (
        <th
          key={i}
          // className={i === 8 || i === 10 || i === 12 ? "colspan-head" : ""}
        >
          {header.label}
        </th>
      ))}
    </tr>
  </thead>
);

export default PendingTableHeader;
